<template lang="pug">
div
  v-card
    v-card-title.pb-0 Reserved Sessions
    v-list(v-if="team.reservations && reservations.length")
      v-list-item(v-for="reservation in reservations" :key="reservation.id")
        v-list-item-content
          .body-2.font-weight-bold {{reservation.session.facility_hours.athletic_space.facility.facility_name}}
          .body-2 {{reservation.session.facility_hours.athletic_space.name}}
          .body-2(v-if="reservation.session.facility_hours.athletic_space.door") Door: {{reservation.session.facility_hours.athletic_space.door}}
          .body-2 {{slotStringFor(reservation.session)}}
          .body-2(v-if="season.sport=='BASKETBALL'")
            span(v-if="reservation.breakout") {{reservation.breakout.name}}
            span(v-else) Full Space
        v-list-item-action(v-if="isInTimingWindow")
          v-btn(icon aria-label="remove reservation")
            v-icon(color='red' @click="toRemove=reservation.id") mdi-close
    v-card-text(v-else) No reserved sessions.
    v-dialog(v-model="dialogModel" width=250)
      v-card
        v-card-title Release reservation?
        v-list-item(v-if="toRemove")
          v-list-item-content
            .body-2.font-weight-bold {{reservationToRemove.session.facility_hours.athletic_space.facility.facility_name}}
            .body-2 {{reservationToRemove.session.facility_hours.athletic_space.name}}
            .body-2(v-if="reservationToRemove.session.facility_hours.athletic_space.door") Door: {{reservationToRemove.session.facility_hours.athletic_space.name}}
            .body-2 {{slotStringFor(reservationToRemove.session)}}
            .body-2(v-if="season.sport=='BASKETBALL'")
              span(v-if="reservationToRemove.breakout") {{reservationToRemove.breakout.name}}
              span(v-else) Full Space
        v-card-actions
          v-promise-btn(color="red" @click="release").white--text Release
          v-btn(@click="toRemove = undefined") Cancel
</template>

<script>
import { mapGetters } from 'vuex'
import VPromiseBtn from '@/components/VPromiseBtn.vue'

export default {
  components: {
    VPromiseBtn
  },
  data: () => ({
    toRemove: undefined
  }),
  computed: {
    ...mapGetters([
      'season',
      'team',
      'isInTimingWindow'
    ]),
    reservations() {
      return this.team.reservations
    },
    reservationToRemove() {
      return this.reservations.find(r => r.id == this.toRemove)
    },
    dialogModel: {
      get() {
        return !!this.reservationToRemove
      },
      set(value) {
        if(!value)
          this.toRemove = undefined
      }
    }
  },
  methods: {
    slotStringFor(session) {
      return this.$store.getters.slotStringWith({
        start: session.session_start_dtm,
        end: session.session_end_dtm
      }, session.facility_hours.week_day)
    },
    async release() {
      if(this.isInTimingWindow && this.toRemove) {
        await this.$store.dispatch('releaseSession', this.reservationToRemove.session.id)
        await this.$store.dispatch('refresh')
        this.toRemove = undefined
      }
    }
  }
}
</script>